import img_game_logo from 'assets/images/game_logo.min.png';
import img_explosion from 'assets/images/img_explosion.min.png';
import img_mine from 'assets/images/img_mine.min.png';
import img_coin from 'assets/images/img_coin.min.png';
import img_tile01 from 'assets/images/img_tile01.min.png';
import img_tile02 from 'assets/images/img_tile02.min.png';
import sound_button_enable from 'assets/sounds/button_enable.mp3';
import sound_button_hover from 'assets/sounds/button_hover.mp3';
import sound_dynamite_explosion from 'assets/sounds/dynamite_explosion.mp3';
import sound_game_starter from 'assets/sounds/game_starter.mp3';
import sound_gold_reveal from 'assets/sounds/gold_reveal.mp3';
import sound_stone_click from 'assets/sounds/stone_click.mp3';
import sound_stone_hover from 'assets/sounds/stone_hover.mp3';
import sound_win from 'assets/sounds/win.mp3';

import { TFiles } from './types';

export const files: TFiles = {
  image: [
    img_game_logo,
    img_mine,
    img_coin,
    img_tile01,
    img_tile02,
    img_explosion,
  ],
  fetch: [
    sound_button_enable,
    sound_button_hover,
    sound_dynamite_explosion,
    sound_game_starter,
    sound_gold_reveal,
    sound_stone_click,
    sound_stone_hover,
    sound_win,
  ],
  callback: [
    cb => {
      setTimeout(() => {
        cb();
      }, 1000);
    },
  ],
};
